import { supabase } from "../config/supabase";

const DEED_PICS_BUCKET = "deed-pics";

// Resolves a stored pic to something <img src=...> can render.
//
// `pics` in the deeds table are storage object paths (e.g.
// "<userUuid>/<deedId>/<isoTimestamp>.jpg"). The DeedEdit form also displays
// in-flight uploads as `blob:` URLs and may temporarily hold full http(s)
// URLs (e.g. previously stored Spaces URLs during a transitional save), so we
// pass those through untouched.
export function picUrl(picOrPath) {
  if (!picOrPath) return picOrPath;
  if (/^(blob:|https?:\/\/|data:)/i.test(picOrPath)) return picOrPath;
  const { data } = supabase.storage
    .from(DEED_PICS_BUCKET)
    .getPublicUrl(picOrPath);
  return data.publicUrl;
}
